import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

const dataInicial = {
    TipoEquipo: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************
const GET_ALL_TIPOS_EQUIPO = 'GET_ALL_TipoEquipoS'
const GET_TIPO_EQUIPO_BY_ID = 'GET_TipoEquipo_BY_ID'
const GET_TIPO_EQUIPO_BY_ID_TIPO_AREA = 'GET_TIPO_EQUIPO_BY_ID_TIPO_AREA'
const POST_TIPO_EQUIPO = 'POST_TipoEquipo'
const UPDATE_TIPO_EQUIPO = 'UPDATE_TipoEquipo'
const DELETE_TIPO_EQUIPO = 'DELETE_TipoEquipo'
//*******************************************************************************************************************


//MÉTODOS 
export const getAllTiposEquipo = createAsyncThunk(
    GET_ALL_TIPOS_EQUIPO,
    async () => {
        try {
            const fullUrl = host + `TipoEquipo/obtenerPreguntasInstalacion`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen las TipoEquipos: '+JSON.stringify(res.data))
            return res
        } catch (error) {
            console.log(error.res);
        }
    }
)

export const getTipoEquipoById = createAsyncThunk(
    GET_TIPO_EQUIPO_BY_ID,
    async (idTipoEquipo) => {
        try {
            const fullUrl = host + `TipoEquipo/obtenerTipoEquipoById/${idTipoEquipo}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const getTipoEquipoByIdArea = createAsyncThunk(
    GET_TIPO_EQUIPO_BY_ID_TIPO_AREA,
    async (idTipoInstalacion) => {
        try {
            const fullUrl = host + `TipoEquipo/obtenerTipoEquipoByIdArea/${idTipoInstalacion}`
            const res = await axios.get(fullUrl)
            //console.log('Se obtienen los Coches: '+JSON.stringify(res))
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const insertTipoEquipo = createAsyncThunk(
    POST_TIPO_EQUIPO,
    async (data) => {
        try {
            const fullUrl = host + `TipoEquipo/agregarTipoEquipo`
            //alert(JSON.stringify(data))
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const updateTipoEquipo = createAsyncThunk(
    UPDATE_TIPO_EQUIPO,
    async (data) => {
        try {
            const fullUrl = host + `TipoEquipo/actualizarTipoEquipo`
            //alert(JSON.stringify(data))
            const result = await axios.put(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const deleteTipoEquipo = createAsyncThunk(
    DELETE_TIPO_EQUIPO,
    async (idTipoEquipo) => {
        try {
            const fullUrl = host + `TipoEquipo/eliminarTipoEquipo/${idTipoEquipo}`
            const result = await axios.delete(fullUrl)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

//****************************************************************************************************************
//EXPORTS DE MÉTODOS
export const metodosTipoEquipoSlice = createSlice({

    name: 'metodosTipoEquipoSlice',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {

        [getAllTiposEquipo.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD VEHICULOS'+JSON.stringify(payload))
            state.TipoEquipo = payload.data.data

        },
        [getTipoEquipoById.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.TipoEquipo = payload.data.data
        },
        [getTipoEquipoByIdArea.fulfilled]: (state, { payload }) => {
            //console.log('PAYLOAD COCHES'+JSON.stringify(payload))
            state.TipoEquipo = payload.data.data
        },
        [insertTipoEquipo.fulfilled]: (state, { payload }) => {
            state.TipoEquipo = payload.data.data
        },

        [updateTipoEquipo.fulfilled]: (state, { payload }) => {

        },
        [deleteTipoEquipo.fulfilled]: (state, { payload }) => {

        },

    },

})


export const { } = metodosTipoEquipoSlice.actions
export const TipoEquipoReducer = metodosTipoEquipoSlice.reducer